import styled from 'styled-components'
import { layout, LayoutProps, margin, MarginProps } from 'styled-system'

import { TextField, TextFieldProps } from '@mui/material'

export type WrapperProps = MarginProps & LayoutProps

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;

  ${margin}
  ${layout}
`

export const StyledInput = styled(TextField)<TextFieldProps>`
  width: 100%;

  .MuiOutlinedInput-input {
    cursor: pointer;
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-width: 1px;
    }
    &:hover fieldset {
      cursor: pointer;
    }
  }
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
  position: relative;
`
